import { useState, useEffect, useCallback } from "react";
import { apiFetch } from "../../../context/AuthContext";
import { BASE_URL } from "../utils/reportsHelpers";

/** KPI cards data (GET /reports/kpis) — independent of the report catalog so Refresh is cheap. */
const useReportsDashboardData = (currentUser) => {
  const [kpis, setKpis] = useState(null);
  const [kpisLoading, setKpisLoading] = useState(true);
  const [kpisError, setKpisError] = useState(null);

  const fetchKpis = useCallback(async () => {
    if (!currentUser) return;
    setKpisLoading(true);
    setKpisError(null);
    try {
      const res = await apiFetch(`${BASE_URL}/reports/kpis?infinityCode=${currentUser}`, { method: "GET" });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      setKpis(data.kpis || null);
    } catch (err) {
      setKpisError(err.message);
    } finally {
      setKpisLoading(false);
    }
  }, [currentUser]);

  useEffect(() => { fetchKpis(); }, [fetchKpis]);

  return { kpis, kpisLoading, kpisError, refetchKpis: fetchKpis };
};

export default useReportsDashboardData;
